module.exports = __webpack_public_path__ + "img/PXL_20230523_142300337.f2f8ceda.jpg";